import React, { useState, useEffect, useContext } from 'react';
import ChatModule from '../components/ChatModule';
import { AudioContext } from '../App'; 

// --- COMPOSANT LECTEUR AUDIO ---
const CustomPlayer = () => {
  const audioCtx = useContext(AudioContext);
  
  const isPlaying = audioCtx ? audioCtx.isPlaying : false;
  const togglePlay = audioCtx ? audioCtx.togglePlay : () => console.error("Context non trouvé");

  const [track, setTrack] = useState({
    title: "Chargement...",
    artist: "Fréquence 974",
    cover: "https://www.radioking.com/play/frequence-9742/cover"
  });

  const fetchTrack = async () => {
    try {
      const response = await fetch('https://api.radioking.io/widget/radio/frequence-9742/track/current');
      const data = await response.json();
      setTrack({
        title: data.title || "Titre inconnu",
        artist: data.artist || "Fréquence 974",
        cover: data.cover || "https://www.radioking.com/play/frequence-9742/cover"
      });
    } catch (error) { console.error("Erreur API RadioKing:", error); }
  };

  useEffect(() => {
    fetchTrack();
    const interval = setInterval(fetchTrack, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="d-flex flex-column align-items-center justify-content-center p-3 p-md-4 h-100 bg-black">
      {!isPlaying && (
        <div className="mb-3 w-100 text-center">
          <button 
            onClick={togglePlay}
            /* Hauteur réduite : py-1 et fontSize plus petit */
            className="btn btn-warning rounded-pill px-4 py-1 fw-black text-uppercase shadow-lg pulse-button border-white border-opacity-25"
            style={{ fontSize: '0.85rem', letterSpacing: '1px' }}
          >
            <i className="bi bi-play-fill fs-5 me-1"></i>
            Lancer la lecture
          </button>
        </div>
      )}

      <div 
        className="position-relative mb-3 mb-md-4 shadow-lg overflow-hidden rounded-4 cover-wrapper" 
        style={{ width: '100%', maxWidth: '280px', aspectRatio: '1/1', cursor: 'pointer' }}
        onClick={togglePlay}
      >
        <img 
          src={track.cover} 
          alt="Cover" 
          className={`img-fluid transition-all duration-500 ${!isPlaying ? 'opacity-50 blur-sm' : 'opacity-100 scale-hover'}`} 
          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
        />
        <div className="position-absolute bottom-0 end-0 m-2">
          <span className="badge rounded-pill bg-danger shadow-sm border border-white border-opacity-25" style={{fontSize: '0.6rem'}}>DIRECT</span>
        </div>
      </div>

      <div className="text-center w-100 px-2 pb-1">
        <h4 className="fw-black text-uppercase text-truncate mb-1 text-white" style={{ fontSize: 'clamp(1rem, 4vw, 1.3rem)' }}>{track.title}</h4>
        <p className="text-primary fw-bold text-uppercase small tracking-widest mb-0 opacity-75" style={{ fontSize: '0.75rem' }}>{track.artist}</p>
      </div>
    </div>
  );
};

// --- COMPOSANT HISTORIQUE ---
const PlayedTracks = () => {
  const [history, setHistory] = useState([]);
  const fetchHistory = async () => {
    try {
      const response = await fetch('https://api.radioking.io/widget/radio/frequence-9742/track/history?limit=2');
      const data = await response.json();
      setHistory(data);
    } catch (error) { console.error(error); }
  };
  useEffect(() => { fetchHistory(); const i = setInterval(fetchHistory, 30000); return () => clearInterval(i); }, []);

  return (
    <div className="mt-4 p-4 rounded-5 bg-black bg-opacity-40 border border-secondary border-opacity-10">
      <h6 className="fw-black text-uppercase mb-3 small opacity-50 tracking-widest text-white" style={{fontSize: '0.7rem'}}>Titres Précédents</h6>
      {history.map((t, i) => (
        <div key={i} className="d-flex align-items-center mb-2 p-2 rounded-3 hover-bg transition-all">
          <img src={t.cover} className="rounded-2 me-3 shadow-sm" style={{width: '40px', height: '40px', objectFit: 'cover'}} alt="cover" />
          <div className="text-truncate">
            <div className="fw-bold small text-white text-truncate">{t.title}</div>
            <div className="text-primary extra-small fw-bold uppercase tracking-tighter">{t.artist}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

// --- COMPOSANT PRINCIPAL LIVE ---
const Live = () => {
  const [isLive, setIsLive] = useState(false);

  const checkLiveStatus = async () => {
    try {
      const response = await fetch('https://live.frequence974.com/api/status');
      const data = await response.json();
      setIsLive(data.online);
    } catch (error) {
      setIsLive(false);
    }
  };

  useEffect(() => {
    checkLiveStatus();
    const interval = setInterval(checkLiveStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-dark min-vh-100 text-white">
      <div className="container pt-4 pt-md-5 pb-5">
        <div className="row justify-content-center">
          <div className="col-lg-11">
            
            {/* Header Status */}
            <div className="d-flex align-items-center justify-content-between mb-4 bg-black bg-opacity-40 p-3 rounded-4 border border-secondary border-opacity-10 shadow-sm">
              <div className="d-flex align-items-center">
                <div className="live-indicator me-3"><span className="dot"></span><span className="pulse"></span></div>
                <div>
                  <h5 className="fw-black text-uppercase mb-0 italic" style={{ fontSize: 'clamp(0.9rem, 4vw, 1.2rem)' }}>Fréquence 974</h5>
                  <small className="text-danger fw-bold uppercase tracking-widest" style={{ fontSize: '0.65rem' }}>
                    {isLive ? "En Direct Vidéo & Audio" : "En Direct Radio"}
                  </small>
                </div>
              </div>
              <div className="d-none d-md-block">
                <span className="badge bg-dark border border-secondary border-opacity-25 text-uppercase fw-black" style={{fontSize: '9px', letterSpacing: '1px'}}>Studio HD</span>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-lg-7">
                

                <div className="player-container shadow-2xl rounded-5 overflow-hidden border border-primary border-opacity-20 bg-black">
                  <div className="player-header p-3 d-flex justify-content-between align-items-center border-bottom border-secondary border-opacity-10">
                    <span className="small fw-bold text-secondary text-uppercase tracking-widest" style={{fontSize: '0.7rem'}}>Audio HD Player</span>
                    <i className="bi bi-broadcast text-danger small"></i>
                  </div>
                  <div className="custom-responsive-height">
                    <CustomPlayer />
                  </div>
                </div>
                <PlayedTracks />
                {isLive && (
                  <div className="video-container shadow-2xl rounded-5 overflow-hidden border border-primary border-opacity-20 bg-black mb-4 animate-fade-in">
                    <div className="player-header p-3 d-flex justify-content-between align-items-center border-bottom border-secondary border-opacity-10 bg-dark bg-opacity-30">
                      <span className="small fw-bold text-primary text-uppercase tracking-widest" style={{fontSize: '0.7rem'}}>Live Cam Studio</span>
                      <div className="d-flex align-items-center">
                         <span className="badge bg-danger me-2" style={{fontSize: '0.6rem'}}>ON AIR</span>
                         <i className="bi bi-camera-video-fill text-danger small"></i>
                      </div>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src="https://live.frequence974.com/embed/video"
                        title="Frequence974 Live Vidéo"
                        referrerPolicy="origin"
                        allowFullScreen
                        style={{ border: 'none' }}
                      ></iframe>
                    </div>
                  </div>
                )}
              </div>

              <div className="col-lg-5">
                <div className="sticky-lg-top" style={{ top: '20px' }}>
                  <ChatModule height={isLive ? "780px" : "600px"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .fw-black { font-weight: 900; }
        .italic { font-style: italic; }
        .tracking-widest { letter-spacing: 0.2em; }
        .extra-small { font-size: 0.65rem; }
        .hover-bg:hover { background: rgba(30, 127, 203, 0.1); }
        .live-indicator { position: relative; width: 10px; height: 10px; }
        .dot { position: absolute; width: 10px; height: 10px; background-color: #ff0000; border-radius: 50%; z-index: 2; }
        .pulse { position: absolute; width: 10px; height: 10px; background-color: #ff0000; border-radius: 50%; animation: pulse-ring 1.5s infinite; }
        @keyframes pulse-ring { 0% { transform: scale(.33); } 80%, 100% { opacity: 0; } }
        
        .player-container, .video-container { box-shadow: 0 0 60px rgba(0, 0, 0, 0.5); }
        
        .scale-hover { transition: transform 0.8s ease; }
        .cover-wrapper:hover .scale-hover { transform: scale(1.08); }

        .animate-fade-in { animation: fadeIn 0.6s ease-out; }
        @keyframes fadeIn { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

        .pulse-button { animation: button-glow 2s infinite; transition: all 0.3s; }
        .pulse-button:hover { transform: scale(1.02); background-color: #ffc107 !important; }

        @keyframes button-glow {
          0% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0.5); }
          70% { box-shadow: 0 0 0 12px rgba(255, 193, 7, 0); }
          100% { box-shadow: 0 0 0 0 rgba(255, 193, 7, 0); }
        }

        .custom-responsive-height { height: auto; }
        @media (min-width: 992px) {
          .custom-responsive-height { height: 420px; }
        }
      `}</style>
    </div>
  );
};

export default Live;